import React, { Component } from 'react'

import { Container, Image, Text } from './styledComponents'

export default class PlaceToPlayIbcricket extends Component {
  render() {
    const { item: { image, alt, text } } = this.props

    return (
      <Container>
        <Image dataSrc={image} alt={alt} className="lazyload" />
        <Text as="div">{text}</Text>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/PlacesToPlayIbcricket/PlacesListToPlayIbcricket/PlaceToPlayIbcricket/index.js